<template>
    <div>
        <h2 class="title typographies-heading-h2">{{ $l10n.__('Critères de comparaison') }}</h2>
        <p class="subtitle typographies-paragraph-medium-regular">
            {{ getTypeImport.comparisonCriteriaDescription }}
        </p>
        <div class="identifier-option__container">
            <div
                v-for="(identifier, key) in identifiers"
                :key="key"
                class="identifier-option__item"
            >
                <div class="identifier-title">
                    <span class="typographies-paragraph-medium-bold">
                        {{ identifier.title }}
                    </span>
                    <CompassTooltip contentClass="tooltip-import-options" placement="bottom-start">
                        <template #content>
                            <div v-for="choice in identifier.choices" :key="choice.value">
                                <h4 class="typographies-heading-h4">{{ choice.label }}</h4>
                                <p class="typographies-paragraph-small-bold">
                                    {{ choice.description }}
                                </p>
                            </div>
                        </template>
                        <CompassIcon icon="info-circle-fill" size="small" />
                    </CompassTooltip>
                </div>
                <div v-if="identifier.multiple" class="identifier-content">
                    <CompassFormItem :error="errorMsgSelect(identifiersSelected[key])" label="">
                        <CompassSelect
                            v-model="identifiersSelected[key]"
                            :error="errorMsgSelect(identifiersSelected[key]).length > 0"
                            multiple
                            menuClass="menu-import-dialog"
                        >
                            <CompassDropdownOption
                                v-for="(choice, keyChoice) in identifier.choices"
                                v-bind="choice"
                                :key="keyChoice"
                                type="checkbox"
                                @click.prevent
                            />
                        </CompassSelect>
                    </CompassFormItem>
                </div>
                <CompassRadioGroup
                    v-else
                    v-model="identifiersSelected[key][0]"
                    direction="horizontal"
                >
                    <CompassRadio
                        v-for="(choice, keyChoice) in identifier.choices"
                        :key="choice.value"
                        :checked="isSelected(choice, keyChoice)"
                        :label="choice.label"
                        :modelValue="choice.value"
                        size="medium"
                    />
                </CompassRadioGroup>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const importsStore = createNamespacedHelpers('importsStore');
export default {
    data() {
        return {
            identifiers: null,
            identifiersSelected: null,
            parameters: null,
        };
    },
    computed: {
        ...importsStore.mapGetters([
            'getTypeImport',
            'getOptionsImport',
            'getOptionsSelectedImport',
            'getCurrentSubStep',
        ]),
    },
    watch: {
        'getOptionsSelectedImport.identifiers': {
            handler(oldIdentifiers, newIdentifiers) {
                for (const identifier of Object.values(newIdentifiers ?? oldIdentifiers)) {
                    this.getCurrentSubStep.isValid = identifier.length > 0;
                    if (identifier.length === 0) {
                        break;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.identifiers = this.getOptionsImport.identifiers;
        this.identifiersSelected = this.getOptionsSelectedImport.identifiers;
        this.parameters = this.getOptionsImport.parameters;
    },
    methods: {
        isSelected(choice, key) {
            return this.identifiersSelected[key] === choice.value;
        },
        errorMsgSelect(identifiers) {
            return identifiers.length === 0
                ? this.$l10n.__('Sélectionnez au moins un critère de comparaison')
                : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.identifier-option {
    &__container {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-4);
    }
    &__item {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-0);
    }
}
.identifier-title:deep() {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);

    .compass-icon {
        color: var(--colors-common-icon-neutral);
    }
}
</style>

<style lang="scss">
.tooltip-import-options {
    max-width: 392px;
    z-index: 1002;
    white-space: pre-line;

    .compass-tooltip__item__content {
        display: flex;
        flex-direction: column;
        gap: 12px;

        h4,
        p {
            margin: 0;
        }
    }
}
</style>
